function outfit_grid(){
  var productslider = [];
  document.querySelectorAll('.opg-prod-media-slider').forEach(function(Element){
    if (!(Element instanceof HTMLElement)) return;
    let productid = Element.dataset.id;
    let nextbutton = Element.querySelector('.swiper-button-next');
    let prevbutton = Element.querySelector('.swiper-button-prev');
    if(!nextbutton || !prevbutton) return;
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerView: 1,
      a11y: false,
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      },
    };
    productslider[productid] = new Swiper(Element, swiperObject);
    let parentMedia = Element.closest('.ch-items-media');
    if(parentMedia){
      parentMedia.querySelectorAll('.ch-mb-meta-inr').forEach((ch_meta, index) => {
        ch_meta.addEventListener('click', function(e){
          if (!ch_meta.classList.contains('redirect_to')){
            e.preventDefault();
            let i = index + 1;
            productslider[productid].slideTo(i);
            ch_meta.classList.add('redirect_to');
          }
        });
      });
    }
  });
}
outfit_grid();
if(document.querySelectorAll('.opg-prod-cont')){
  function opgProdCont(){
    let count = 0;
    document.querySelectorAll('.opg-prod-cont').forEach(function(prod_content){
      prod_content.querySelectorAll('.opg-variant-grid').forEach(function(sizeList){
        sizeList.addEventListener('click',function(e){
          e.preventDefault();
          prod_content.querySelectorAll('.opg-variant-grid').forEach(function(sizelist_rm){
            sizelist_rm.classList.remove('active-variant');
          });
          sizeList.classList.add('active-variant');
          prod_content.querySelectorAll('.opg-variant-grid.active-variant').forEach(function(sizelist_active){
            count = count + 1;
          });
          prod_content.closest('.opg-prod-meta-wrapper').querySelector('.prod-meta-btm').classList.add('active-add-cart');
          console.log(count,'count');
          if(count > 1){
            prod_content.closest('.opg-prod-meta-wrapper').querySelector('.prod-meta-btm').classList.add('multi-add');
          }
          if(window.innerWidth > 991){
            let variant_id = sizeList.dataset.id;
            let error_grid_outer;
            if(sizeList.closest('.ch-items-inr')){
              error_grid_outer = sizeList.closest('.ch-items-inr');
            }else if(sizeList.closest('.opg-product-block')){
              error_grid_outer = sizeList.closest('.opg-product-block');
            }else{
              error_grid_outer = sizeList.closest('.snippet-product-grid');
            }
            let error_grid = error_grid_outer.querySelector('.grid-error');
            let formData = {
              'items': [{
                'id': variant_id,
                'quantity': 1
              }]
            };
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
            .then((response) => response.json())
            .then((data) => {
              if(data.status == 422)
              {
                error_grid.innerHTML = data.description;
                setTimeout(function(e){
                  error_grid.innerHTML = '';
                },2000);
              }else{          
                if(document.location.href.indexOf('/cart') > -1) {
                  window.location.href = "/cart";
                }else{
                  if(typeof load_cart == 'function'){
                    cartNotification(data.items[0].id);
                    load_cart();
                  }else{
                    window.location.href = "/cart";
                  }          
                }
                const url = '/cart.js';
                fetch(url)
                .then((resp) => resp.json())
                .then(function(data) {
                  var cart_count = data.item_count;
                  if(cart_count>0){
                    document.querySelector('.cart-count').innerHTML = ' ['+ cart_count +']';
                  }else{
                    document.querySelector('.cart-count').innerHTML = '';
                  }
                })
                .catch(function(error) {
                  console.log(error);
                })
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
        });
      });
    });
  }
  opgProdCont();
}
function initHoverSlide(){
  // if (window.innerWidth < 992) return;
  document.querySelectorAll('.opg-product-block, .ch-items-inr').forEach(block => {
    const swiperEl = block.querySelector('.swiper');
    const swiperInstance = swiperEl?.swiper;
    if (!swiperInstance) return;
    const slides = block.querySelectorAll('.swiper-slide');
    block.querySelectorAll('.opg-prod-cont').forEach(prodCont => {
      prodCont.addEventListener('mouseenter', () => {
        if(window.innerWidth >= 992){
          const targetVal = prodCont.getAttribute('data-val');
          const targetIndex = Array.from(slides)
            .findIndex(slide => slide.getAttribute('data-val') === targetVal);
          if (targetIndex !== -1) {
            swiperInstance.slideTo(targetIndex);
          }
        }
      });
      prodCont.addEventListener('mouseleave', () => {
        if(window.innerWidth >= 992){
          swiperInstance.slideTo(0);
        }
      });
    });
  });
}
initHoverSlide();
window.addEventListener('resize', initHoverSlide);
if (document.querySelector('.ch-items-inr.opg-product-block')) {
  document.querySelectorAll('.ch-items-inr.opg-product-block').forEach(function (collHigh) {
    let swiperEl = collHigh.querySelector('.swiper');
    let swiperInstance = swiperEl?.swiper;
    if (!swiperInstance) return;

    collHigh.addEventListener('mouseover', function (e) {
      if (window.innerWidth >= 992) {
        if (e.target.closest('.opg-prod-meta')) return;
        swiperInstance.slideTo(1);
      }
    });

    collHigh.addEventListener('mouseout', function (e) {
      if (window.innerWidth >= 992) {
        if (e.target.closest('.opg-prod-meta')) return;
        swiperInstance.slideTo(0);
      }
    });
  });
}
